import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { createGtm } from '@gtm-support/vue-gtm'
import { gtm } from '@/utils/define'
import VueLazyLoad from 'vue-lazyload'

const app = createApp(App)
const pinia = createPinia()

app.use(
  createGtm({
    id: gtm,
    vueRouter: router,
    defer: false,
  })
)
app.use(VueLazyLoad)
app.use(pinia)
app.use(router)
app.mount('#app')
